import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { moduleByKeys } from '~/assets/modules';
import { useGetAccountQuery } from '~/types/types';
var iconMapping = {
  'company-information': require('~/assets/icons/company-info/blue.svg'),
  esg: require('~/assets/icons/esg-assessment/blue.svg'),
  'eu-taxonomy': require('~/assets/icons/environmental.svg'),
  metrics: require('~/assets/icons/metrics/blue.svg'),
  'impact-goals': require('~/assets/icons/impact-goals/blue.svg')
};
var iconMappingMuted = {
  'company-information': require('~/assets/icons/company-info/grey.svg'),
  esg: require('~/assets/icons/esg-assessment/grey.svg'),
  'eu-taxonomy': require('~/assets/icons/environmental.svg'),
  metrics: require('~/assets/icons/metrics/grey.svg'),
  'impact-goals': require('~/assets/icons/impact-goals/grey.svg')
};
export default defineComponent({
  setup: function setup() {
    var route = useRoute();
    var ventureId = route === null || route === void 0 ? void 0 : route.params.venture;
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId
      }),
      accountResult = _useGetAccountQuery.result;
    var venture = computed(function () {
      var _accountResult$value;
      return ((_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) || {
        modules: [],
        portfolioLinks: []
      };
    });
    var bookedModules = computed(function () {
      var _venture$value;
      return ((_venture$value = venture.value) === null || _venture$value === void 0 ? void 0 : _venture$value.bookedModules) || [];
    });
    var flatModules = computed(function () {
      return Object.keys(moduleByKeys).flatMap(function (key) {
        return moduleByKeys[key].subModules || [];
      });
    });
    return {
      venture: venture,
      bookedModules: bookedModules,
      flatModules: flatModules
    };
  },
  methods: {
    isBooked: function isBooked(submodule) {
      var _this$bookedModules;
      return (_this$bookedModules = this.bookedModules) === null || _this$bookedModules === void 0 ? void 0 : _this$bookedModules.some(function (m) {
        var _submodule$showForMod;
        return (_submodule$showForMod = submodule.showForModules) === null || _submodule$showForMod === void 0 ? void 0 : _submodule$showForMod.includes(m);
      });
    },
    iconFor: function iconFor(submodule) {
      return this.isBooked(submodule) ? iconMapping[submodule.id] : iconMappingMuted[submodule.id];
    },
    iconImageClass: function iconImageClass(submodule) {
      if (submodule.id === 'eu-taxonomy' && this.isBooked(submodule)) {
        return 'module-card__img--eu-taxonomy-active';
      }
      return '';
    }
  }
});